var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZapFilled = function SvgZapFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.992 2.124a1 1 0 0 0-1.76-.764l-8.93 10.715c-.154.185-.31.373-.424.538-.108.155-.304.462-.31.864a1.5 1.5 0 0 0 .557 1.19c.313.253.674.298.863.315.199.018.443.018.684.018h6.195l-.86 6.876a1 1 0 0 0 1.761.764l8.93-10.715c.154-.185.31-.373.424-.538.108-.155.304-.462.31-.864a1.5 1.5 0 0 0-.557-1.19c-.313-.253-.674-.298-.863-.315C19.812 9 19.57 9 19.328 9h-6.195z"
  })));
};
export default SvgZapFilled;